import { ReportRequest } from '@/client/reports';
import { DepartmentPerformanceChart } from '@/ui/charts/bar-chart/DepartmentPerformanceChart';
import { RadarChart } from '@/ui/charts/radar-chart';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled(FlexContainer)`
  @media screen and (max-width: 1279px) {
    & {
      flex-wrap: wrap;

      > div {
        flex: none;
      }
    }
  }
`;

type PhishingAnalysisProps = {
  filters: ReportRequest;
};

export const PhishingAnalysis = ({ filters }: PhishingAnalysisProps) => {
  return (
    <StyledContainer
      align="stretch"
      justify="space-between"
      gap={24}
      className="mt-4"
    >
      <RadarChart filters={filters} />
      <DepartmentPerformanceChart filters={filters} />
    </StyledContainer>
  );
};
